import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Manage Clocks</h3>
                <p className="text-sm text-gray-600">
                    Track and manage employee clock-in and clock-out activities, locations, and durations.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">View Records</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Use the <strong>Date Range Picker</strong> to filter records by specific dates.</li>
                    <li>Use the <strong>Search Bar</strong> to find specific records by user name or other details.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Exports</h4>
                <p className="text-sm text-gray-600 mb-2">
                    You can export the clock history data for reporting purposes.
                </p>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Select rows using the checkboxes in the table to export specific records.</li>
                    <li>Click <strong>PDF</strong> or <strong>CSV</strong> buttons to download the report.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Table Features</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Clock In/Out Location:</strong> Shows the GPS coordinates where the action occurred.</li>
                    <li><strong>Duration:</strong> Total time worked for the shift.</li>
                    <li><strong>Status:</strong> Current status of the clock record.</li>
                </ul>
            </section>
        </div>
    );
};

export default Help;
